import { z } from 'zod'

// shape of the store persisted in the guest store and user store cookies.
// see slimGuestStore util.
export const guestStoreSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().catch(''),
  store_location_id: z.number().int().positive(),
  metro_id: z.number().int().positive(),
  is_pickup: z.boolean().catch(false),
})
